const set_global_client = (state, client) => {
  state.globalClient = client;
};

const set_global_contractor = (state, contractor) => {
  state.globalContractor = contractor;
};

const SHOW_ERROR_ALERT = (state, payload) => {
  state.alert_variant = "danger";
  state.alert_show = true;
  state.alert_text = payload;
};

const RESET_ALERT = state => {
  state.alert_variant = null;
  state.alert_show = false;
  state.alert_text = [];
};

export default {
  set_global_client,
  set_global_contractor,
  SHOW_ERROR_ALERT,
  RESET_ALERT
};
